( function( $, window ) {
	'use strict';

	var $window;
	var $sidebar;
	var $siteFooter;
	var $siteMainContent;
	var fixedClassName = 'is-fixed';
	var stoppedClassName = 'is-stopped';
	var resizeTimer;

	function positionSidebar() {
		var topPadding = ( $window.height() - $sidebar.height() ) / 2;
		var bottomPadding = parseFloat( $siteMainContent.css( 'padding-bottom' ) );

		if ( $window.scrollTop() > $siteMainContent.offset().top - topPadding && window.matchMedia( '(min-width: 1024px)' ).matches ) {
			if ( $window.scrollTop() < $siteFooter.offset().top - $sidebar.height() - bottomPadding - topPadding ) {
				$sidebar.removeClass(stoppedClassName ).addClass( fixedClassName ).css( {
					top: '',
					width: $sidebar.parent().width()
				} );
			} else {
				$sidebar.removeClass( fixedClassName ).addClass( stoppedClassName ).css( {
					top: $siteFooter.offset().top - $sidebar.height() - bottomPadding - $siteMainContent.offset().top,
					width: $sidebar.parent().width()
				} );
			}

		} else {
			$sidebar.removeClass( fixedClassName ).removeClass( stoppedClassName ).css( {
				top: '',
				width: ''
			} );
		}
	}

	function registerScrollHandler() {
		$window.on( 'scroll.qrc.course', function() {
			positionSidebar();
		} );
	}

	function registerResizeHandler() {
		$window.on( 'resize.qrc.course', function() {
			clearTimeout( resizeTimer );
			resizeTimer = setTimeout( function() {
				positionSidebar();
			}, 250 );
		} );
	}

	$( function() {
		$window = $( window );
		$sidebar = $( '.js-course-sidebar' );
		$siteFooter = $( '.js-site-footer' );
		$siteMainContent = $( '.js-site-main-content' );

		enquire.register( '(min-width: 1024px)', {
			match: function() {
				if ( $sidebar.length ) {
					registerScrollHandler();
					registerResizeHandler();
					positionSidebar();
				}
			},
			unmatch: function() {
				if ( $sidebar.length ){
					$window.off( 'scroll.qrc.course' );
					$window.off( 'resize.qrc.course' );
					$sidebar.removeClass( fixedClassName ).removeClass( stoppedClassName ).css( {
						top: '',
						width: ''
					} );
				}
			}
		} );
	} );
} )( jQuery, window );
